import styled from "styled-components";
import { useGetMessagesQuery } from "../../../data/generated";
import { theme } from "../../../theme";
import { LogDetailsRow } from "./LogDetailsRow";
import { Loader } from "../../../design-system/atoms/Loader";
import { LogFilters } from "../types";

export const LogsList = ({ filters }: { filters: LogFilters }) => {
  const { data, loading, error, fetchMore } = useGetMessagesQuery({
    variables: { limit: 50, offset: 0, filters },
    fetchPolicy: "cache-and-network",
  });

  if (error) {
    return null;
  }

  if (loading || !data) {
    return <Loader />;
  }

  const {
    messages: { messages, hasMore },
  } = data;

  function handleScroll({ currentTarget }: React.UIEvent<HTMLDivElement>) {
    if (
      currentTarget.scrollTop + currentTarget.clientHeight >=
      currentTarget.scrollHeight
    ) {
      if (hasMore) {
        fetchMore({
          variables: {
            offset: messages.length,
            limit: 50,
            filters,
          },
        });
      }
    }
  }

  return (
    <Container>
      <Table onScroll={handleScroll}>
        <HeaderRow>
          <HeaderCell style={{ width: 170 }}>Send date</HeaderCell>
          <HeaderCell style={{ width: 100 }}>Sender</HeaderCell>
          <HeaderCell style={{ width: 300 }}>Topic</HeaderCell>
          <HeaderCell style={{ flex: 1 }}>Body</HeaderCell>
        </HeaderRow>
        {messages.length === 0 ? (
          <NoResultContainer>
            <p>No logs found</p>
          </NoResultContainer>
        ) : (
          messages.map((message) => (
            <LogDetailsRow key={message._id} message={message} />
          ))
        )}
      </Table>
    </Container>
  );
};

const Container = styled.div`
  flex: 1;
  border: 1px solid ${theme.borderColor.highlight};
  border-radius: 10px;
  overflow: hidden;
  z-index: 0;
`;

const Table = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;

const HeaderRow = styled.div`
  position: sticky;
  top: 0px;
  display: flex;
  flex-direction: row;
  padding: 5px;
  gap: 10px;
  background-color: ${theme.backgroundColor};
  z-index: 1;
`;

const HeaderCell = styled.div`
  padding: 5px;
  color: ${theme.textColor.default};
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
  font-weight: bold;
`;

const NoResultContainer = styled.div`
  display: flex;
  justify-content: center;
  color: ${theme.textColor.secondary};
`;
